// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__cHyHF","contactItem":"contact_contactItem__iy3kR","info":"contact_info__EpdKV","itemsGroup":"contact_itemsGroup__npnjc"};